import React from 'react';
import { Form, DatePicker } from 'antd';
import styles from './formComponents.module.scss';

const ChoiceDateField = ({
  label,
  name,
  getFieldDecorator,
  initialValue,
  required = true,
  className,
  colon = false,
  validationRules = [],
  datePickerProps = {},
}) => {
  return (
    <div id={`${name}-container`} className={className}>
      <Form.Item label={label} colon={colon}>
        {getFieldDecorator(name, {
          initialValue,
          rules: [
            { type: 'object', required: required, message: 'Выберите дату' },
            ...validationRules,
          ],
        })(
          <DatePicker
            {...datePickerProps}
            className={styles.datePicker}
            dropdownClassName={styles.datePickerDropdown}
            getCalendarContainer={() =>
              document.getElementById(`${name}-container`)
            }
            format="DD.MM.YYYY"
            showToday={false}
          />
        )}
      </Form.Item>
    </div>
  );
};

export default ChoiceDateField;
